import { render, staticRenderFns } from "./SalaryLifecycle.vue?vue&type=template&id=3a5c7fa8"
import script from "./SalaryLifecycle.vue?vue&type=script&lang=js"
export * from "./SalaryLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports